export default "<div class=\"desktopWrapper\">\n    <app-docdashboard>\n      \n    </app-docdashboard>\n  </div>\n  ";